const DAYS_OF_WEEK = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'];

/**
 * Converte string "HH:mm" para minutos desde meia-noite.
 * @param {string} timeStr - Ex: "14:30"
 * @returns {number|null} Ex: 870
 */
function parseTimeToMinutes(timeStr) {
    if (!timeStr || typeof timeStr !== 'string') return null;
    const parts = timeStr.split(':');
    if (parts.length < 2) return null;
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    if (isNaN(hours) || isNaN(minutes)) return null;
    return hours * 60 + minutes;
}

/**
 * Filtra documentos (categorias ou itens) por disponibilidade de dia/hora.
 * Port frontend da funcao backend storeAvailability.filterByAvailability.
 *
 * - disponibilidade "pausado" -> nunca visivel
 * - disponibilidade "sempre" ou undefined -> sempre visivel
 * - disponibilidade "especificos" -> visivel apenas nos horarios configurados
 *
 * @param {Array} documents - Array de itens/categorias da API
 * @param {string} [timezone='America/Sao_Paulo'] - Timezone string
 * @returns {Array} Documentos filtrados que estao disponiveis agora
 */
export function filterByAvailability(documents, timezone = 'America/Sao_Paulo') {
    if (!documents || documents.length === 0) return [];

    const now = new Date();

    // Obter hora e dia atual no timezone da empresa
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
        weekday: 'short',
    });

    const parts = formatter.formatToParts(now);
    const hourPart = parts.find(p => p.type === 'hour');
    const minutePart = parts.find(p => p.type === 'minute');
    const weekdayPart = parts.find(p => p.type === 'weekday');

    const currentHour = parseInt(hourPart.value, 10);
    const currentMinute = parseInt(minutePart.value, 10);
    const currentMinutes = currentHour * 60 + currentMinute;

    const dayMap = { Sun: 'domingo', Mon: 'segunda', Tue: 'terca', Wed: 'quarta', Thu: 'quinta', Fri: 'sexta', Sat: 'sabado' };
    const currentDay = dayMap[weekdayPart.value];

    return documents.filter((doc) => {
        // Pausado = nunca visivel
        if (doc.disponibilidade === 'pausado') return false;

        // Sempre ou sem definicao = sempre visivel
        if (doc.disponibilidade === 'sempre' || !doc.disponibilidade) return true;
        if (doc.disponibilidade !== 'especificos') return true;

        const horarios = doc.dia_horario_disponibilidade;
        if (!horarios || !Array.isArray(horarios)) return true;

        return horarios.some((hora) => {
            if (hora.dia !== currentDay) return false;

            const start = parseTimeToMinutes(hora.startTime);
            const end = parseTimeToMinutes(hora.endTime);

            if (start === null || end === null) return false;

            // Periodo que cruza meia-noite (ex: 22:00 - 02:00)
            if (end < start) {
                return currentMinutes >= start || currentMinutes <= end;
            }

            return currentMinutes >= start && currentMinutes <= end;
        });
    });
}

export default filterByAvailability;
